import React, { useState } from "react"
import styled from "@emotion/styled"
import { Global, css } from "@emotion/core"
import { Formik } from "formik"
import * as Yup from "yup"
import * as Sentry from "@sentry/browser"

import ButtonSubmit from "../ui/button-submit"

const ContainerFormWorkWithUs = styled.div`
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
`

const Title = styled.h2`
  font-size: 33px;
  line-height: 116%;
  color: #000000;
  max-width: 600px;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 60px;
  padding: 0 20px;
  @media (max-width: 1023px) {
    font-size: 27px;
    line-height: 116%;
    margin-top: 50px;
    margin-bottom: 24px;
    padding: 0 25px;
  }
`

const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100%;
`

const ContainerForm = styled.div`
  @media (min-width: 768px) {
    margin-top: -15px;
  }
`

const Description = styled.p`
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin-bottom: 40px;
  max-width: 295px;
  margin-top: 0;
  @media (min-width: 768px) {
    max-width: 457px;
  }
  @media (min-width: 1024px) {
    max-width: 587px;
  }
`

const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-evenly;
    min-width: 740px;
    flex-wrap: wrap;
  }
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 380px;
  @media (max-width: 380px) {
    padding: 0 20px;
    max-width: 380px;
    width: 100%;
  }
`

const Label = styled.label`
  font-size: 14px;
  line-height: 14px;
  color: #363f41;
  margin-bottom: 5px;
  width: 100%;
  &.error {
    color: #f17575;
  }
`

const Input = styled.input`
  background: #ffffff;
  border: 1px solid #e4e4e4;
  box-sizing: border-box;
  min-height: 48px;
  margin-bottom: 10px;
  padding: 8px;
  width: 100%;
  &.error {
    border: 1px solid #f17575;
  }
`

const ContainerSuccessful = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  order: 3;
  max-width: 350px;
  margin: 160px 0;
`

const SuccessfulText = styled.strong`
  color: #62aa46;
`

const Radiobutton = styled.div`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  margin-right: 20px;
`

const ContainerRadio = styled.label``

const TextRadioButton = styled.span`
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
`

const ContainerGroupRadioButton = styled.div`
  display: flex;
  width: 100%;
`

const buttonCSS = css`
  height: 64px;
  & > div {
    & > div {
      width: 20px;
      height: 20px;
      border-width: 3px;
    }
  }
`

const FileName = styled.span`
  font-family: "Open Sans";
  font-size: 12px;
  padding-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  width: 190px;
  position: absolute;
  top: calc(50% - 8.5px);
  &.mobile {
    display: none;
    @media (max-width: 380px) {
      display: inline;
      width: 100px;
    }
  }
  &.desktop {
    display: none;
    @media (min-width: 381px) {
      display: inline;
    }
  }
`

const ButtonUpload = styled.input`
  background-color: #838383;
  border: none;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  height: 48px;
  width: 114px;
  padding: 0 20px;
  box-sizing: content-box;
  font-size: 10px;
  line-height: 14px;
`

const ContainerUpload = styled.div`
  background-color: #fff;
  border-radius: 5px;
  display: inline-block;
  max-width: 380px;
  padding: 0 10px 0 0;
  position: relative;
  border: 1px solid #e8e8e8;
  width: 100%;
  &.error {
    border: 1px solid #f17575;
  }
  &:hover {
    opacity: 0.95;
  }
`

const InputUpload = styled.input`
  width: 100%;
  height: 48px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  left: 0;
  border: 1px solid #e8e8e8;
  z-index: 10;
`

const SuccessImg = styled.img`
  width: 130px;
  height: 130px;
`

const FormCV = () => {
  const [sendFormsuccessful, setSendFormsuccessful] = useState(false)

  const supportedFormats = [
    "application/msword",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ]

  const FormCVSchema = Yup.object().shape({
    name: Yup.string()
      .min(3)
      .required("Este campo es requerido"),
    email: Yup.string()
      .email("El email ingresado no es válido")
      .required("Este campo es requerido"),
    phone: Yup.string()
      .required("Este campo es requerido")
      .matches(
        /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\\./0-9]*$/,
        "El número de teléfono solo puede incluir números, -, +, () y espacios"
      )
      .min(
        7,
        "El número de teléfono es muy corto - mínimo, debería tener 7 caracteres"
      )
      .required(),
    country: Yup.string().required(),
    file: Yup.mixed()
      .test(
        "fileSize",
        "fileSize",
        value => value && value.size && value.size <= 3 * 1024 * 1024
      )
      .test(
        "fileType",
        "Archivo no soportado",
        value => value && value.type && supportedFormats.includes(value.type)
      )
      .required(),
  })

  const onSubmit = async (values: any, { setSubmitting }: any) => {
    try {
      const formData = new FormData()
      formData.append("name", values.name)
      formData.append("email", values.email)
      formData.append("phone", values.phone)
      formData.append("country", values.country)
      formData.append("file", values.file)

      const response = await fetch(
        "https://master.backend.capitaria.com/api/upload-cv",
        {
          body: formData,
          credentials: "omit",
          method: "post",
        }
      )

      if (response.status === 200) {
        setSendFormsuccessful(true)
      }
    } catch (err) {
      setSubmitting(false)
      Sentry.captureException(err)
    }
  }

  return (
    <ContainerFormWorkWithUs>
      <Title className="work-with-us">Déjanos tus datos</Title>
      <WrapperForm>
        <ContainerHeader>
          <Description>
            En Capitaria estamos expectantes de cualquier talento que quiera
            unirse a nuestra familia, no importando si conoce o no el mundo del
            Trading. Tenemos un programa de capacitación que te llevará de cero
            a trader en poco tiempo.
          </Description>
        </ContainerHeader>
        {!sendFormsuccessful ? (
          <ContainerForm>
            <Global
              styles={{
                ".container": {
                  display: "block",
                  position: "relative",
                  paddingLeft: "35px",
                  marginBottom: "12px",
                  cursor: "pointer",
                  fontSize: "22px",
                  userSelect: "none",
                },
                ".container.error": {
                  color: "#f17575",
                },
                ".container input": {
                  position: "absolute",
                  opacity: 0,
                  cursor: "pointer",
                },
                ".checkmark": {
                  position: "absolute",
                  top: "0",
                  left: "0",
                  height: "21px",
                  width: "21px",
                  backgroundColor: "#ffffff",
                  borderRadius: "50%",
                  border: "1px solid #d9d9d9",
                },
                ".container:hover input ~ .checkmark": {
                  backgroundColor: "#ccc",
                },
                ".container input:checked ~ .checkmark": {
                  backgroundColor: "#71c552",
                },
                ".checkmark:after": {
                  content: '""',
                  position: "absolute",
                  display: "none",
                },
                ".container input:checked ~ .checkmark:after": {
                  display: "block",
                },
                ".container .checkmark:after": {
                  top: "6px",
                  left: "6px",
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  background: "white",
                },
              }}
            />
            <Formik
              initialValues={{
                name: "",
                email: "",
                phone: "",
                country: "",
                file: null,
              }}
              validationSchema={FormCVSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                setFieldValue,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                isValidating,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Label htmlFor="name">Nombre Completo</Label>
                  <Input
                    type="text"
                    name="name"
                    className={errors.name && touched.name ? "error" : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                  />
                  <Label htmlFor="email">Email</Label>
                  <Input
                    type="email"
                    name="email"
                    className={errors.email && touched.email ? "error" : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                  />
                  <Label htmlFor="phone">Teléfono</Label>
                  <Input
                    type="tel"
                    name="phone"
                    className={errors.phone && touched.phone ? "error" : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone}
                  />

                  <Label htmlFor="country">País</Label>
                  <ContainerGroupRadioButton>
                    <Radiobutton>
                      <ContainerRadio
                        className={`container ${
                          errors.country && touched.country ? "error" : ""
                        }`}
                      >
                        <TextRadioButton>Chile</TextRadioButton>
                        <input
                          type="radio"
                          name="country"
                          value="Chile"
                          checked={values.country === "Chile"}
                          onBlur={handleBlur}
                          onChange={event => {
                            setFieldValue("country", "Chile")
                            handleChange(event)
                          }}
                        />
                        <span className="checkmark" />
                      </ContainerRadio>
                    </Radiobutton>
                    <Radiobutton>
                      <ContainerRadio
                        className={`container ${
                          errors.country && touched.country ? "error" : ""
                        }`}
                      >
                        <TextRadioButton>Peru</TextRadioButton>
                        <input
                          type="radio"
                          name="country"
                          value="Peru"
                          checked={values.country === "Peru"}
                          onBlur={handleBlur}
                          onChange={event => {
                            setFieldValue("country", "Peru")
                            handleChange(event)
                          }}
                        />
                        <span className="checkmark" />
                      </ContainerRadio>
                    </Radiobutton>
                    <Radiobutton>
                      <ContainerRadio
                        className={`container ${
                          errors.country && touched.country ? "error" : ""
                        }`}
                      >
                        <TextRadioButton>Uruguay</TextRadioButton>
                        <input
                          type="radio"
                          name="country"
                          value="Uruguay"
                          checked={values.country === "Uruguay"}
                          onBlur={handleBlur}
                          onChange={event => {
                            setFieldValue("country", "Uruguay")
                            handleChange(event)
                          }}
                        />
                        <span className="checkmark" />
                      </ContainerRadio>
                    </Radiobutton>
                  </ContainerGroupRadioButton>
                  <Label htmlFor="file">Curriculum</Label>
                  <ContainerUpload
                    className={`${errors.file && touched.file ? "error" : ""}`}
                  >
                    <ButtonUpload type="button" value="SELECCIONAR" />
                    <InputUpload
                      type="file"
                      name="file"
                      onBlur={handleBlur}
                      onChange={event => {
                        if (
                          event.currentTarget.files &&
                          event.currentTarget.files.length > 0
                        ) {
                          setFieldValue("file", event.currentTarget.files[0])
                        }
                      }}
                      accept={supportedFormats.join(",")}
                    />
                    <FileName className="mobile">
                      {values.file !== null
                        ? // @ts-ignore
                          values.file.name
                        : "3 Mb máximo"}
                    </FileName>
                    <FileName className="desktop">
                      {values.file !== null
                        ? // @ts-ignore
                          values.file.name
                        : "Peso máximo 3 Mb"}
                    </FileName>
                  </ContainerUpload>
                  <ButtonSubmit
                    disabled={isValidating}
                    loading={isSubmitting}
                    buttonCSS={buttonCSS}
                    text="Enviar"
                  />
                </Form>
              )}
            </Formik>
          </ContainerForm>
        ) : (
          <ContainerSuccessful>
            <div>
              <SuccessImg src="/work-with-us/success.gif" alt="Éxito" />
            </div>
            <div>
              <SuccessfulText>
                Tus datos fueron enviados con éxito.
              </SuccessfulText>
              <br />
              Nos contactaremos contigo apenas tengamos un nuevo cargo
              disponible
            </div>
          </ContainerSuccessful>
        )}
      </WrapperForm>
    </ContainerFormWorkWithUs>
  )
}

export default FormCV
